import React from 'react';
import Abacus2025  from 'views/Abacus2025';


const ExtraCurricularActivitiesPage = () => {
    
  return <Abacus2025 />;
};

export default ExtraCurricularActivitiesPage;